import styled from 'styled-components'
import { BLACK, GRAYSCALE_500, NEUTRAL_100 } from '../../styles/colors'
import { GIVONIC, INTER } from '../../styles/fonts'

export const MenuItemContainer = styled.div<{ $isClickable: boolean }>`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 16px 14px;
    border: 1px solid ${NEUTRAL_100};
    border-radius: 12px;
    cursor: ${props => props.$isClickable ? 'pointer' : 'default'};
`

export const ContentContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 2px;
`

export const Title = styled.span`
    font-family: ${GIVONIC.bold};
    font-size: 16px;
    color: ${BLACK};
`

export const Description = styled.span`
    font-family: ${INTER.light};
    font-size: 12px;
    color: ${GRAYSCALE_500};
`
